/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SearchRouteImport } from './routes/search'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as BillingIndexRouteImport } from './routes/billing/index'
import { Route as BillingCancelledRouteImport } from './routes/billing/cancelled'
import { Route as BillingCreditsRouteImport } from './routes/billing/credits'
import { Route as BillingInvoicesRouteImport } from './routes/billing/invoices'
import { Route as BillingSuccessRouteImport } from './routes/billing/success'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as LeadsLeadIdRouteImport } from './routes/leads/$leadId'
import { Route as ReportsGenerateRouteImport } from './routes/reports.generate'
import { Route as ReportsSqlRouteImport } from './routes/reports.sql'
import { Route as CampaignsCampaignIdIndexRouteImport } from './routes/campaigns/$campaignId/index'
import { Route as CampaignsCampaignIdDetailsRouteImport } from './routes/campaigns/$campaignId/details'
import { Route as CampaignsCreateIndexRouteImport } from './routes/campaigns/create/index'
import { Route as CampaignsCreateFormRouteImport } from './routes/campaigns/create/form'
import { Route as CampaignsCampaignIdLeadsLeadIdRouteImport } from './routes/campaigns/$campaignId/leads/$leadId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingCancelledRoute = BillingCancelledRouteImport.update({
  id: '/billing/cancelled',
  path: '/billing/cancelled',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingCreditsRoute = BillingCreditsRouteImport.update({
  id: '/billing/credits',
  path: '/billing/credits',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingInvoicesRoute = BillingInvoicesRouteImport.update({
  id: '/billing/invoices',
  path: '/billing/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSuccessRoute = BillingSuccessRouteImport.update({
  id: '/billing/success',
  path: '/billing/success',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsLeadIdRoute = LeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsGenerateRoute = ReportsGenerateRouteImport.update({
  id: '/reports/generate',
  path: '/reports/generate',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSqlRoute = ReportsSqlRouteImport.update({
  id: '/reports/sql',
  path: '/reports/sql',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdIndexRoute =
  CampaignsCampaignIdIndexRouteImport.update({
    id: '/campaigns/$campaignId/',
    path: '/campaigns/$campaignId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CampaignsCampaignIdDetailsRoute =
  CampaignsCampaignIdDetailsRouteImport.update({
    id: '/campaigns/$campaignId/details',
    path: '/campaigns/$campaignId/details',
    getParentRoute: () => rootRouteImport,
  } as any)
const CampaignsCreateIndexRoute = CampaignsCreateIndexRouteImport.update({
  id: '/campaigns/create/',
  path: '/campaigns/create/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCreateFormRoute = CampaignsCreateFormRouteImport.update({
  id: '/campaigns/create/form',
  path: '/campaigns/create/form',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdLeadsLeadIdRoute =
  CampaignsCampaignIdLeadsLeadIdRouteImport.update({
    id: '/campaigns/$campaignId/leads/$leadId',
    path: '/campaigns/$campaignId/leads/$leadId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/cancelled': typeof BillingCancelledRoute
  '/billing/credits': typeof BillingCreditsRoute
  '/billing/invoices': typeof BillingInvoicesRoute
  '/billing/success': typeof BillingSuccessRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/reports/generate': typeof ReportsGenerateRoute
  '/reports/sql': typeof ReportsSqlRoute
  '/billing/': typeof BillingIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/campaigns/$campaignId/details': typeof CampaignsCampaignIdDetailsRoute
  '/campaigns/create/form': typeof CampaignsCreateFormRoute
  '/campaigns/$campaignId/': typeof CampaignsCampaignIdIndexRoute
  '/campaigns/create/': typeof CampaignsCreateIndexRoute
  '/campaigns/$campaignId/leads/$leadId': typeof CampaignsCampaignIdLeadsLeadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/cancelled': typeof BillingCancelledRoute
  '/billing/credits': typeof BillingCreditsRoute
  '/billing/invoices': typeof BillingInvoicesRoute
  '/billing/success': typeof BillingSuccessRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/reports/generate': typeof ReportsGenerateRoute
  '/reports/sql': typeof ReportsSqlRoute
  '/billing': typeof BillingIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/campaigns/$campaignId/details': typeof CampaignsCampaignIdDetailsRoute
  '/campaigns/create/form': typeof CampaignsCreateFormRoute
  '/campaigns/$campaignId': typeof CampaignsCampaignIdIndexRoute
  '/campaigns/create': typeof CampaignsCreateIndexRoute
  '/campaigns/$campaignId/leads/$leadId': typeof CampaignsCampaignIdLeadsLeadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/cancelled': typeof BillingCancelledRoute
  '/billing/credits': typeof BillingCreditsRoute
  '/billing/invoices': typeof BillingInvoicesRoute
  '/billing/success': typeof BillingSuccessRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/reports/generate': typeof ReportsGenerateRoute
  '/reports/sql': typeof ReportsSqlRoute
  '/billing/': typeof BillingIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/campaigns/$campaignId/details': typeof CampaignsCampaignIdDetailsRoute
  '/campaigns/create/form': typeof CampaignsCreateFormRoute
  '/campaigns/$campaignId/': typeof CampaignsCampaignIdIndexRoute
  '/campaigns/create/': typeof CampaignsCreateIndexRoute
  '/campaigns/$campaignId/leads/$leadId': typeof CampaignsCampaignIdLeadsLeadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/register'
    | '/search'
    | '/auth/callback'
    | '/billing/cancelled'
    | '/billing/credits'
    | '/billing/invoices'
    | '/billing/success'
    | '/leads/$leadId'
    | '/reports/generate'
    | '/reports/sql'
    | '/billing/'
    | '/campaigns/'
    | '/campaigns/$campaignId/details'
    | '/campaigns/create/form'
    | '/campaigns/$campaignId/'
    | '/campaigns/create/'
    | '/campaigns/$campaignId/leads/$leadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/register'
    | '/search'
    | '/auth/callback'
    | '/billing/cancelled'
    | '/billing/credits'
    | '/billing/invoices'
    | '/billing/success'
    | '/leads/$leadId'
    | '/reports/generate'
    | '/reports/sql'
    | '/billing'
    | '/campaigns'
    | '/campaigns/$campaignId/details'
    | '/campaigns/create/form'
    | '/campaigns/$campaignId'
    | '/campaigns/create'
    | '/campaigns/$campaignId/leads/$leadId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/register'
    | '/search'
    | '/auth/callback'
    | '/billing/cancelled'
    | '/billing/credits'
    | '/billing/invoices'
    | '/billing/success'
    | '/leads/$leadId'
    | '/reports/generate'
    | '/reports/sql'
    | '/billing/'
    | '/campaigns/'
    | '/campaigns/$campaignId/details'
    | '/campaigns/create/form'
    | '/campaigns/$campaignId/'
    | '/campaigns/create/'
    | '/campaigns/$campaignId/leads/$leadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  SearchRoute: typeof SearchRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BillingCancelledRoute: typeof BillingCancelledRoute
  BillingCreditsRoute: typeof BillingCreditsRoute
  BillingInvoicesRoute: typeof BillingInvoicesRoute
  BillingSuccessRoute: typeof BillingSuccessRoute
  LeadsLeadIdRoute: typeof LeadsLeadIdRoute
  ReportsGenerateRoute: typeof ReportsGenerateRoute
  ReportsSqlRoute: typeof ReportsSqlRoute
  BillingIndexRoute: typeof BillingIndexRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  CampaignsCampaignIdDetailsRoute: typeof CampaignsCampaignIdDetailsRoute
  CampaignsCreateFormRoute: typeof CampaignsCreateFormRoute
  CampaignsCampaignIdIndexRoute: typeof CampaignsCampaignIdIndexRoute
  CampaignsCreateIndexRoute: typeof CampaignsCreateIndexRoute
  CampaignsCampaignIdLeadsLeadIdRoute: typeof CampaignsCampaignIdLeadsLeadIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/': {
      id: '/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/cancelled': {
      id: '/billing/cancelled'
      path: '/billing/cancelled'
      fullPath: '/billing/cancelled'
      preLoaderRoute: typeof BillingCancelledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/credits': {
      id: '/billing/credits'
      path: '/billing/credits'
      fullPath: '/billing/credits'
      preLoaderRoute: typeof BillingCreditsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/invoices': {
      id: '/billing/invoices'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof BillingInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/success': {
      id: '/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof BillingSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads/$leadId': {
      id: '/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof LeadsLeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/generate': {
      id: '/reports/generate'
      path: '/reports/generate'
      fullPath: '/reports/generate'
      preLoaderRoute: typeof ReportsGenerateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/sql': {
      id: '/reports/sql'
      path: '/reports/sql'
      fullPath: '/reports/sql'
      preLoaderRoute: typeof ReportsSqlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId/': {
      id: '/campaigns/$campaignId/'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId/'
      preLoaderRoute: typeof CampaignsCampaignIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId/details': {
      id: '/campaigns/$campaignId/details'
      path: '/campaigns/$campaignId/details'
      fullPath: '/campaigns/$campaignId/details'
      preLoaderRoute: typeof CampaignsCampaignIdDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/create/': {
      id: '/campaigns/create/'
      path: '/campaigns/create'
      fullPath: '/campaigns/create/'
      preLoaderRoute: typeof CampaignsCreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/create/form': {
      id: '/campaigns/create/form'
      path: '/campaigns/create/form'
      fullPath: '/campaigns/create/form'
      preLoaderRoute: typeof CampaignsCreateFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId/leads/$leadId': {
      id: '/campaigns/$campaignId/leads/$leadId'
      path: '/campaigns/$campaignId/leads/$leadId'
      fullPath: '/campaigns/$campaignId/leads/$leadId'
      preLoaderRoute: typeof CampaignsCampaignIdLeadsLeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  SearchRoute: SearchRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BillingCancelledRoute: BillingCancelledRoute,
  BillingCreditsRoute: BillingCreditsRoute,
  BillingInvoicesRoute: BillingInvoicesRoute,
  BillingSuccessRoute: BillingSuccessRoute,
  LeadsLeadIdRoute: LeadsLeadIdRoute,
  ReportsGenerateRoute: ReportsGenerateRoute,
  ReportsSqlRoute: ReportsSqlRoute,
  BillingIndexRoute: BillingIndexRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  CampaignsCampaignIdDetailsRoute: CampaignsCampaignIdDetailsRoute,
  CampaignsCreateFormRoute: CampaignsCreateFormRoute,
  CampaignsCampaignIdIndexRoute: CampaignsCampaignIdIndexRoute,
  CampaignsCreateIndexRoute: CampaignsCreateIndexRoute,
  CampaignsCampaignIdLeadsLeadIdRoute: CampaignsCampaignIdLeadsLeadIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
